/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var fulfills =
  function (algs) { return function (test) { return algs.indexOf(test) !== -1; }; }

module.exports = fulfills



//////////////////
// WEBPACK FOOTER
// ./~/crocks/core/implements.js
// module id = ./node_modules/crocks/core/implements.js
// module chunks = 0